<template>
  <div class="withdraw">
    <navbar>
      <template #left>
        <!-- <span class="material-icons">chevron_left</span> -->
        <svg t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="21829" width=".6rem" height=".6rem">
          <path
            d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
            fill="#ffffff" p-id="21830"></path>
        </svg>
      </template>
      <template #title>
        <span style="color: #fff;font-size: .4267rem;">
          {{ $t('user.t16') }}
        </span>
      </template>
      <template #right>
        <!-- <span class="material-icons" @click="$router.push('/serve')">support_agent</span> -->
        <svg @click="$router.push('/serve')" t="1748486049022" class="icon" viewBox="0 0 1046 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="11906" width=".6rem" height=".6rem">
          <path
            d="M907.377778 521.398044c0-234.245689-181.771378-393.398044-384-393.398044-200.112356 0-384 155.739022-384 395.946667A83.968 83.968 0 0 0 96.711111 597.333333V682.666667A85.583644 85.583644 0 0 0 182.044444 768h42.666667V507.721956c0-165.114311 133.552356-298.666667 298.666667-298.666667s298.666667 133.575111 298.666666 298.689422v302.921956h-341.333333v85.333333h341.333333a85.583644 85.583644 0 0 0 85.333334-85.333333v-52.064711c25.167644-13.198222 42.666667-39.253333 42.666666-69.973334V590.506667c0-29.878044-17.499022-55.887644-42.666666-69.108623z"
            p-id="11907" fill="#fff"></path>
          <path
            d="M395.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333zM651.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333z"
            p-id="11908" fill="#fff"></path>
          <path
            d="M779.377778 470.607644c-20.48-121.605689-126.293333-214.607644-253.860978-214.607644-129.274311 0-268.379022 107.087644-257.297067 275.205689 105.403733-43.099022 184.775111-136.965689 207.371378-251.312356 55.887644 112.207644 170.666667 189.44 303.786667 190.714311z"
            p-id="11909" fill="#fff"></path>
        </svg>
      </template>
    </navbar>
    <div class="content">
      <div class="card">
        <div class="top">
          <div class="price">
            ${{ userinfo?.balance }}
          </div>
          <div class="txt">
            {{ $t('user.t17') }}
          </div>
        </div>
        <div class="bottom">
          <div class="account" style="margin-bottom: .4rem;">
            <div class="txt">
              {{ $t('user.t18') }}
            </div>
            <div class="txt">
              {{ userinfo?.username }}
            </div>
          </div>
          <!-- <div class="phone">
            <div class="txt">
              {{ $t('user.t19') }}
            </div>
            <div class="txt">
              {{ hiddenPhone }}
            </div>
          </div> -->
          <van-radio-group v-model="radio">
            <van-radio name="wallet">{{ $t('user.t62') }}</van-radio>
            <van-radio name="bank">{{ $t('user.t63') }}</van-radio>
            <van-radio name="USDT">{{ $t('movie.t07') }}</van-radio>
          </van-radio-group>
          <!-- <input type="text" class="ipt" placeholder="USDT code" v-if="radio === 'USDT'" v-model="usdtCode"> -->
          <div class="usdtRadio" v-if="radio === 'USDT'">
            <van-radio-group v-model="usdtRadio" checked-color="#121212">
              <van-radio shape="square" icon-size=".4rem" name="erc20" :disabled="!hasValue(walletObj.erc20)">
                <span class="label">ERC20</span>
                <span class="val">{{ walletObj.erc20 ? walletObj.erc20 : $t('movie.t08') }}</span>
              </van-radio>
              <van-radio shape="square" icon-size=".4rem" name="trc20" :disabled="!hasValue(walletObj.trc20)">
                <span class="label">TRC20</span>
                <span class="val">{{ walletObj.trc20 ? walletObj.trc20 : $t('movie.t08') }}</span>

              </van-radio>
              <van-radio shape="square" icon-size=".4rem" name="btc" :disabled="!hasValue(walletObj.btc)">
                <span class="label">BTC</span>
                <span class="val">{{ walletObj.btc ? walletObj.btc : $t('movie.t08') }}</span>

              </van-radio>
            </van-radio-group>
            <div class="goWalletBtn" @click="$router.push('/bankwallet')">{{ $t('movie.t04') }}</div>
          </div>
        </div>
      </div>
      <div class="hint">
        {{ $t('user.t20') }}
      </div>
      <input type="text" class="ipts" v-model="price" :placeholder="$t('user.t22')">
      <input type="password" class="ipts" v-model="pwd" :placeholder="$t('user.t23')">
      <div class="btn" @click="getWithdraw">
        {{ $t('user.t21') }}
      </div>
      <div class="mute">
        <!-- 1.Alcance com sucesso a conta 3-5 minutos após a retirada<br> -->
        <!-- 1.Nenhuma taxa é exigida para saques<br>
        2.A retirada será recebida com sucesso dentro de 10 a 15 minutos após a retirada. Para saques após o horário
        comercial, o recebimento será feito no próximo horário comercial. -->
        {{ $t('user.t91') }}<br> {{ $t('user.t92') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: '0',
      price: '',
      pwd: '',
      usdtCode: '',
      userinfo: JSON.parse(localStorage.getItem('userInfo')),
      cardnum: '',
      // 链上地址支付信息
      walletObj: {
        erc20: '',
        trc20: '',
        btc: '',
      },
      usdtRadio: ''
    }
  },
  mounted() {
    this.$http.getBindBank().then(res => {
      if (res.data.info) {
        this.cardnum = res.data.info.id;
      }
    })
  },
  computed: {
    // 计算属性返回部分隐藏的电话号码
    hiddenPhone() {
      return this.userinfo?.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }
  },
  created() {
    // 获取链上地址信息
    this.getBindBank();
  },
  methods: {
    getWithdraw() {
      if (this.radio == '0') {
        this.radio = 'wallet'
      }
      if (!this.price) {
        this.$toast(this.$t('user.t22'))
        return
      }
      if (!this.pwd) {
        this.$toast(this.$t('user.t23'))
        return
      }

      // 判断USDT
      if (this.radio === 'USDT' && !this.hasValue(this.usdtRadio)) {
        this.$toast(this.$t('movie.t09'));
        return
      }
      // if (this.usdtCode !== '') {
      //   localStorage.setItem('usdtCode', this.usdtCode);
      // }
      // if (this.userinfo?.balance < 30) {
      //   this.usdtCode = ''
      //   this.price = ''
      //   this.pwd = ''
      //   this.$toast.fail({
      //     message: this.$t('user.t76'),
      //     duration: 8000
      //   })
      //   setTimeout(() => {
      //     this.$router.push('/recharge')
      //   }, 1000);
      //   return
      // }



      let params = new URLSearchParams();
      params.append('type', this.radio);
      params.append('bk_id', this.cardnum);
      params.append('num', this.price);
      params.append('paypassword', this.pwd);
      params.append('_csrf_', '60436ac94ba92');
      params.append('whats_verify', 0);

      // USDT
      if (this.hasValue(this.usdtRadio)) {
        params.append('USDT_code', this.walletObj[this.usdtRadio]);
        params.append('USDT_type', this.usdtRadio);
      }

      this.$http.setWithdraw(params).then(res => {
        if (res.code == 0) {
          this.$toast.success(res.info);
          // this.usdtCode = ''
          this.price = ''
          this.pwd = ''
          this.$router.push('/user')
        }
        else {
          // this.usdtCode = ''
          // this.price = ''
          // this.pwd = ''
          this.$toast.fail({
            message: res.info,
            duration: 800
          })
          // setTimeout(() => {
          //   this.$router.push('/recharge')
          // }, 1000);
        }
      })
    },
    // 获取支付信息
    getBindBank() {
      this.$http.getBindWallet().then(res => {
        if (res.code === 0) {
          const info = res?.data?.info || {};

          // 1) 赋值到 walletObj（只取 walletObj 里已有的 key）
          Object.keys(this.walletObj).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(info, key) && info[key] != null) {
              this.walletObj[key] = info[key];
            }
          });

          // 2) 找下标最近（按顺序第一个）且有值的 key，赋值给 usdtRadio
          const hitKey = Object.keys(this.walletObj).find((key) => {
            return typeof this.walletObj[key] === 'string' && this.walletObj[key].trim().length > 0;
          });

          this.usdtRadio = hitKey || '';
        }
      });
    },
    hasValue(v) {
      return typeof v === 'string'
        ? v.trim().length > 0
        : v !== null && v !== undefined;
    }
  }
}
</script>
<style lang="less" scoped>
.usdtRadio {
  background-color: #f1f1f1;
  padding: .2rem;
  border-radius: .1rem;

  span.label {
    font-size: .3rem;
    font-weight: 700;
    margin-right: .3rem;
  }

  span.val {
    font-size: .26rem;
    font-weight: 700;
    color: #666;
  }

  .goWalletBtn {
    color: #fff;
    font-size: .3rem;
    font-weight: 700;
    text-align: center;
    background-color: #121212;
    padding: .2rem 0;
    border-radius: .1rem;
    margin-top: .4rem;
  }
}

::v-deep {
  .van-radio__label {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.withdraw {
  .material-icons {}

  span {}

  .content {
    margin-top: .64rem;
    padding: 0 .4rem;

    .card {
      .top {
        // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
        background-color: #121212;
        border-top-left-radius: .2667rem;
        border-top-right-radius: .2667rem;
        padding: .4rem;
        height: 3.2rem;
        text-align: center;
        color: #fff;

        .price {
          font-size: .8rem;
        }

        .txt {
          font-size: .4267rem;
        }
      }

      .bottom {
        border-radius: .2667rem;
        padding: .4rem;
        background-color: #fff;
        margin-top: -0.8rem;

        .account {
          margin-bottom: .2133rem;
          display: flex;

          .txt {
            font-size: .32rem;

            &:first-child {
              flex: 0 0 41%;
            }

            &:last-child {
              flex: 1;
            }
          }
        }

        .phone {
          display: flex;
          margin-bottom: .2133rem;

          .txt {
            font-size: .32rem;

            &:first-child {
              flex: 0 0 41%;
            }

            &:last-child {
              flex: 1;
            }
          }
        }

        .ipt {
          margin-top: .2133rem;
          background-color: #121212;
          border-radius: .1333rem;
          height: .6rem;
          width: calc(100% - .8267rem);
          padding: .2133rem .4267rem;
          color: #fff;
          font-size: .48rem;

          &::placeholder {
            font-size: .4267rem;
          }
        }
      }
    }

    .hint {
      margin-top: .8rem;
      margin-bottom: .4rem;
      color: #fff;
    }

    .ipts {
      margin-top: .2667rem;
      display: block;
      width: 100%;
      height: 1.1rem;
      background-color: #121212;
      border-radius: .1333rem;
      padding: .2133rem .4267rem;
      color: #fff;
      font-size: .4267rem;
      border: 1px solid #D44246;
      box-sizing: border-box;
    }

    .btn {
      color: #fff;
      background-color: #121212;
      margin-top: .64rem;
      padding: .3467rem 0;
      border-radius: .8rem;
      text-align: center;
    }

    .mute {
      margin-top: .4267rem;
      font-size: .32rem;
      color: #fff;
    }
  }

  ::v-deep {
    .van-radio {
      margin-bottom: .2133rem;
    }

    .van-radio__label {
      font-size: .32rem;
    }
  }

}
</style>
